module.exports = __webpack_public_path__ + "static/media/1_03.c88db090.jpg";